import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import Widget, { Props } from "../Widget";
import useWebservice from "../../hooks/useWebservice";
import { WidgetData } from "../../lib/types";

const RankingWidgetEmbed = (props: Props & { widgetId: string }) => {
  const webservice = useWebservice();

  const [widgetProps, setWidgetProps] = React.useState<Props>(props);

  useTopic(`widget:${props.widgetId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
      case "ranking:update":
        setWidgetProps(message.payload as Props);
        break;
    }
  });

  useTopic(`user:widgets:${props.type}:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  React.useEffect(() => {
    let now = new Date();

    const interval = setInterval(() => {
      // Every time a day pass, we must refresh the widget
      if (now.getDate() !== new Date().getDate()) {
        webservice
          .get<WidgetData>(`/widgets/${props.widgetId}`)
          .then(({ data }) => {
            setWidgetProps((current) => ({ ...current, ...data }));
          })
          .catch(() => {});
      }
    }, 60_000);

    return () => clearInterval(interval);
  }, []);

  return <Widget visible={true} {...widgetProps} />;
};

export default RankingWidgetEmbed;
